// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__iz-AR","fullScreen":"style_fullScreen__3XpbZ","hidden":"style_hidden__2aL6x"};